import React from 'react';

let defaultValue:object = [];
const SceneContainerContext = React.createContext(defaultValue as any);

export default SceneContainerContext;